import React, { useState, useEffect } from "react";
import "./QuestionNavigation.css";
import QuestionStatus from "../../../../../shared/components/questionStatus/QuestionStatus";
import "./QuestionNavigation.css";
import Sidebar from "../../../../../shared/components/Sidebar/Sidebar";

function QuestionNavigation() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [sections, setSections] = useState([]);

  useEffect(() => {
    const sampleData = {
      sections: [
        {
          name: "Physics Section A",
          questions: Array.from({ length: 40 }, (_, i) => ({
            id: i + 1,
            status: [
              "notVisited",
              "answered",
              "notAnswered",
              "marked",
              "answeredMarked",
            ][Math.floor(Math.random() * 5)],
          })),
        },
        {
          name: "Physics Section B",
          questions: Array.from({ length: 20 }, (_, i) => ({
            id: i + 41,
            status: [
              "notVisited",
              "answered",
              "notAnswered",
              "marked",
              "answeredMarked",
            ][Math.floor(Math.random() * 5)],
          })),
        },
      ],
    };
    setSections(sampleData.sections);
  }, []);

  return (
    <>
      <button onClick={() => setIsSidebarOpen(true)}>Open Sidebar</button>
      <Sidebar
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        width="382px"
        height="1181px"
        position="right"
        backgroundColor="#fff"
        color="#000"
        padding="20px"
        boxShadow="-2px 0px 8px rgba(0,0,0,0.15)"
      >
        <div className="qn-sidebar">
          <h3 className="qn-title">All Questions</h3>

          <QuestionStatus />

          {/* Sections */}
          {sections.map((section, idx) => (
            <div key={idx} className="qn-section">
              <h4>{section.name}</h4>
              <div className="qn-grid">
                {section.questions.map((q) => (
                  <div key={q.id} className={`qn-button ${q.status}`}>
                    <span className="qn-number">{q.id}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Sidebar>
    </>
  );
}

export default QuestionNavigation;
